import { useQuery } from '@tanstack/react-query';
import { getResourceItemDetail } from '../api/resources.member.api';
import { resourcesKeys } from './resources.keys';

/**
 * Full detail for one resource item, including a short-lived `downloadUrl`.
 * Enabled only when `id` is non-null — callers set it lazily on "Open Resource"
 * click for file-type resources so the presigned URL is always fresh.
 *
 * @param id - the resource item UUID, or null when not yet needed.
 */
export function useResourceDetail(id: string | null) {
  return useQuery({
    queryKey: resourcesKeys.item(id ?? ''),
    queryFn: () => getResourceItemDetail(id!),
    enabled: id !== null,
    // Disable background refetch — downloadUrl is short-lived and the caller
    // will set a new id each time the user clicks "Open Resource".
    staleTime: 0,
  });
}
